module.exports = __webpack_public_path__ + "img/bonus_off.8596a93a.png";